import { Size } from "../types";
import { StandardProps } from "@/components/componentMap";
import {
  ButtonSizeThreshold,
  buttonSizeThresholdConfigSchema,
} from "../config/buttonSizeThresholdConfigSchema";

export const getLegacySizeProps = ({
  sizes,
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags"> & {
  sizes: Size[];
}) => {
  const useNewSizeOffers = flags.useNewSizeOffers.value === true;

  const legacySizes = sizes.map((size) =>
    size.unavailable
      ? { ...size, showReduced: false, sizeReductionLabel: "" }
      : size,
  );

  const buttonSizeStyleThreshold: ButtonSizeThreshold | undefined =
    legacySizes.some((size) => size.showReduced) && !useNewSizeOffers
      ? { medium: 12 }
      : buttonSizeThresholdConfigSchema.safeParse(
          configProps?.buttonSizeStyleThreshold,
        )?.data || undefined;

  return {
    sizes: legacySizes,
    buttonSizeStyleThreshold,
    brand: product.brand?.name,
    useNewSizeOffers,
  };
};
